// redirects.ts
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// redirects.ts (change destinations to /app/*)
@Component({ standalone: true, template: '' })
export class RedirectToEmbedNewHigharcComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  ngOnInit() {
    const { builderId, haId, clientId } = this.route.snapshot.params as any;
    const qp = { ...this.route.snapshot.queryParams, builderId, planId: haId, hsid: clientId };
    this.router.navigate(['/app/binders/new', 0], { queryParams: qp, replaceUrl: true });
  }
}

@Component({ standalone: true, template: '' })
export class RedirectToEmbedNewComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  ngOnInit() {
    const { clientId } = this.route.snapshot.params as any;
    const qp = { ...this.route.snapshot.queryParams }; // preserves ?linkmode=true
    this.router.navigate(['/app/binders/new', clientId], { queryParams: qp, replaceUrl: true });
  }
}

@Component({ standalone: true, template: '' })
export class RedirectToEmbedEditComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  ngOnInit() {
    const { binderId } = this.route.snapshot.params as any;
    const qp = { ...this.route.snapshot.queryParams };
    this.router.navigate(['/app/binders/edit', binderId], { queryParams: qp, replaceUrl: true });
  }
}

